import * as $ from 'jquery';
import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { ChangeDetectorRef, Component, NgZone, OnDestroy, ViewChild, OnInit, HostListener, Directive, AfterViewInit, ViewContainerRef, Injectable } from '@angular/core';
import { AppHeaderComponent } from './header/header.component';
import { AppSidebarComponent } from './sidebar/sidebar.component';

import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

import { UserManageInfo } from './../../models/userManageInfo';
import { AuthService } from './../../services/auth.service';
import { LoaderService } from './../../services/loader.service';


/** @title Responsive sidenav */
@Component({
    selector: 'app-full-layout',
    templateUrl: 'full.component.html',
    styleUrls: [],
})
export class FullComponent implements OnDestroy, AfterViewInit {
    mobileQuery: MediaQueryList;
    dir = 'ltr';
    green: boolean;
    blue: boolean;
    dark: boolean;
    minisidebar: boolean;
    boxed: boolean;
    danger: boolean;
    showHide: boolean;
    sidebarOpened;

    public getSpinnerVisible: boolean = false;
    public UserConnected: UserManageInfo;

    public config: PerfectScrollbarConfigInterface = {};
    private _mobileQueryListener: () => void;
  
    constructor(private router: Router, private loaderService: LoaderService, public authService: AuthService, public changeDetectorRef: ChangeDetectorRef, public media: MediaMatcher, public vcr: ViewContainerRef) {
        this.mobileQuery = media.matchMedia('(min-width: 768px)');
        this._mobileQueryListener = () => changeDetectorRef.detectChanges();
        this.mobileQuery.addListener(this._mobileQueryListener);

        if (!this.authService.getToken()) //Se non ha il token deve rifare il login
            this.router.navigate(['auth/login']);

        this.authService.getManageInfo().subscribe(src => {
            this.UserConnected = src;
          if (this.UserConnected.Ruolo == "Impianto" && this.UserConnected.IdImpianto == null) {
            this.router.navigate(['auth/login']);
          }
        });

        this.loaderService.isShowProgressBar
            .subscribe((val: boolean) => setTimeout(() => { this.getSpinnerVisible = val }, 0),
            (err) => setTimeout(() => { this.getSpinnerVisible = false }, 0))
    }

    /* ************************************************************************ */
    /* ******************** CONTROLLI INIT DELL'APPLICAZIONE ****************** */
    /* ************************************************************************ */
  
     ngOnInit() {
       
     }

    /* ************************************************************************ */
    /* *************** FINE CONTROLLI INIT DELL'APPLICAZIONE ****************** */
    /* ************************************************************************ */

    ngOnDestroy(): void {
        this.mobileQuery.removeListener(this._mobileQueryListener);
    }

    ngAfterViewInit() {
        //This is for the topbar search
        (<any>$(".srh-btn, .cl-srh-btn")).on('click', function () {
            (<any>$(".app-search")).toggle(200);
        });
        //This is for the megamenu
    }


}



// WEBPACK FOOTER //
// ./src/app/layouts/full/full.component.ts